import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatTableModule } from '@angular/material/table';
import { AmountPipe } from '../../pipes';

@Component({
  selector: 'equine-ui-nx-show-entry-order-items',
  standalone: true,
  imports: [
    CommonModule,
    MatTableModule,
    AmountPipe
  ],
  templateUrl: './show-entry-order-items.component.html',
  styleUrl: './show-entry-order-items.component.scss',
})
export class ShowEntryOrderItemsComponent {
  @Input() total = 0;
  @Input() orderItems: any[] = [];
  @Input() showData: any = {};

  displayedColumns = ['description', 'quantity', 'unitAmount', 'cost'];

}
